import { useEffect } from 'react';

import { useIntl } from 'react-intl';
import { Row, Col, Form } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { boolean } from 'boolean';

import { useAppSelector } from 'hooks';
import { Select } from 'components/Forms';
import { formatDropdownOptions } from 'utils/Object';
import { AccessRoles } from 'constants/enums';
import { getUserAid } from 'store/oauth/reducer';
import { hasRoleForGroup } from 'utils/Groups';

import { IInvitation } from '../Onboard';

interface SelectGroupAndTypeProps {
  isEMRPatient: boolean;
  dropdownGroups: IGroupInfo[];
}

const SelectGroupAndType = ({ isEMRPatient, dropdownGroups }: SelectGroupAndTypeProps) => {
  const intl = useIntl();
  const { values, validateForm } = useFormikContext<IInvitation>();

  const aid = useAppSelector(getUserAid) || '';

  const groupsOptions = formatDropdownOptions(
    dropdownGroups
      .filter((x) => {
        if (isEMRPatient) return boolean(x.emrUseInvite);
        else return x;
      })
      .filter((x) => hasRoleForGroup(x.gid, AccessRoles.ADMIN, aid)),
    'gid',
    'name'
  );

  useEffect(() => {
    validateForm();
  }, [values.type, values.gid, validateForm]);

  return (
    <>
      <h4 className="mb-4" data-test="invite-form-title">
        {intl.formatMessage({ id: 'startOnboardPatientKey' })}
      </h4>
      <Row>
        <Col md={12}>
          <div
            className="d-flex align-items-center p-4 bg-blue-light mb-4 br-5"
            data-test="group-select-disclaimer"
          >
            <div className="ms-2">{intl.formatMessage({ id: 'groupDisclaimerKey' })}</div>
          </div>
        </Col>
      </Row>
      <Row className="mb-5">
        <Col md={6}>
          <Form.Group className="form-group">
            <Form.Label className="font-weight-bolder">
              {intl.formatMessage({ id: 'chooseYourGroupKey' })}
            </Form.Label>
            <Select
              dataTestId="invite-group-select"
              placeholder={intl.formatMessage({ id: 'selectGroup' })}
              name="gid"
              options={groupsOptions}
              required
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default SelectGroupAndType;
